import { getAvatar } from "../utils/avatars";
import { avatarColor } from "../utils/helpers";

// Flat illustrated marks, one per avatar id. Deliberately abstract and friendly
// rather than photographic — no uploads anywhere in TuneWatch.
function Artwork({ id, fg }) {
  switch (id) {
    case "wave":
      return (
        <>
          <circle cx="32" cy="24" r="10" fill={fg} />
          <path
            d="M10 52c0-10 10-16 22-16s22 6 22 16z"
            fill={fg}
            opacity="0.55"
          />
        </>
      );
    case "bloom":
      return (
        <>
          <circle cx="32" cy="22" r="8" fill={fg} />
          <circle cx="20" cy="38" r="8" fill={fg} opacity="0.55" />
          <circle cx="44" cy="38" r="8" fill={fg} opacity="0.55" />
          <circle cx="32" cy="46" r="7" fill={fg} opacity="0.8" />
        </>
      );
    case "ember":
      return (
        <>
          <path d="M32 12c8 10 14 15 14 24a14 14 0 1 1-28 0c0-9 6-14 14-24z" fill={fg} />
          <circle cx="32" cy="40" r="6" fill="#fff" opacity="0.75" />
        </>
      );
    case "leaf":
      return (
        <>
          <path
            d="M46 14c4 18-6 34-24 34-4-18 6-30 24-34z"
            fill={fg}
            opacity="0.85"
          />
          <path
            d="M22 50c6-12 14-22 24-30"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            fill="none"
            opacity="0.8"
          />
        </>
      );
    case "blush":
    default:
      return (
        <>
          <rect x="14" y="14" width="36" height="36" rx="14" fill={fg} />
          <circle cx="25" cy="31" r="3.5" fill="#fff" />
          <circle cx="39" cy="31" r="3.5" fill="#fff" />
          <path
            d="M25 40c4 3 10 3 14 0"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            fill="none"
          />
        </>
      );
  }
}

export default function Avatar({ avatarId, fallbackKey = "", initial, size = 40 }) {
  const avatar = getAvatar(avatarId);

  // No avatar chosen yet: fall back to a coloured initial so nothing ever looks
  // broken or empty.
  if (!avatar) {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: size * 0.34,
          background: avatarColor(fallbackKey),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: 800,
          fontSize: size * 0.38,
          flexShrink: 0,
        }}
      >
        {(initial || "?").toUpperCase()}
      </div>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      style={{ borderRadius: size * 0.34, flexShrink: 0, display: "block" }}
      aria-hidden="true"
    >
      <rect width="64" height="64" rx="22" fill={avatar.bg} />
      <Artwork id={avatar.id} fg={avatar.fg} />
    </svg>
  );
}
